import React from 'react';
import { motion } from 'framer-motion';
import './ProductsOverview.css';

const ProductsOverview = () => {
  const categories = [
    {
      title: 'Bulk Groceries',
      text: 'Pasta, rice, tins – stack it high, sell it fast.',
      image: 'https://ramsden-int.transforms.svdcdn.com/production/Ramsden-International-Range-Hero-Picture.jpg?w=420&h=312&q=85&auto=format&fit=crop&dm=1724942280&s=35b45b0c8431acd1811dfc31ae8a393e',
      deal: 'Buy 10, Get 2 Free',
      stock: '1000+ Units',
    },
    {
      title: 'Drinks Deals',
      text: 'Fizzy, juice, energy – cases priced to shift.',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWWk1B_9WuNHQV9_aRLuUt29DPSu1XoxHvoQ&s',
      deal: '25% Off Pallets',
      stock: '800+ Cases',
    },
    {
      title: 'Cleaning Kit',
      text: 'Bleach, wipes, bins – bulk up, clean up.',
      image: 'https://m.media-amazon.com/images/I/61-3uNXIfsL._AC_SX679_.jpg',
      deal: '30% Off 50+ Units',
      stock: '700+ Packs',
    },
    {
      title: 'Snack Haul',
      text: 'Crisps, bars, sweets – grab ‘em by the crate.',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSuMcWzobuLu-GUoYUyDsts8Z7IQTv6D2GQCQ&s',
      deal: '3-for-2 All Week',
      stock: '900+ Boxes',
    },
    {
      title: 'Frozen Steals',
      text: 'Pizzas, chips, ice – cold cash makers.',
      image: 'https://dmrqkbkq8el9i.cloudfront.net/Pictures/480xany/0/1/3/278013_poundlandchilledandfrozen2medres_708533.jpg',
      deal: '20% Off Bulk',
      stock: '600+ Packs',
    },
  ];

  return (
    <section id="products" className="products-overview">
      <motion.h2
        className="products-title"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        viewport={{ once: true }}
      >
        Deal Drop Zone
      </motion.h2>
      <div className="products-grid">
        {categories.map((category, index) => (
          <motion.div
            key={index}
            className={`product-tile tile-${index}`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ scale: 1.03 }}
            viewport={{ once: true }}
          >
            <img src={category.image} alt={category.title} className="tile-image" />
            <div className="tile-content">
              <h3 className="tile-title">{category.title}</h3>
              <p className="tile-text">{category.text}</p>
              <div className="tile-stats">
                <span className="deal-tag">{category.deal}</span>
                <span className="stock-tag">{category.stock}</span>
              </div>
              <a href={`#${category.title.toLowerCase().replace(' ', '-')}`} className="tile-link">
                Load Up Now
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ProductsOverview;